import React from "react";

const ContentDefinitionBlock = ({ block }) => {
    if (!block?.title || !block?.text) {
        return null;
    }

    return (
        <aside className="content-definition" aria-label={block.title}>
            {block.eyebrow && (
                <div className="content-definition__eyebrow">
                    {block.eyebrow}
                </div>
            )}
            <div className="content-definition__box">
                {block.label && (
                    <div className="content-definition__label">
                        {block.label}
                    </div>
                )}
                <h2 className="content-definition__title">{block.title}</h2>
                <div
                    className="content-definition__text"
                    dangerouslySetInnerHTML={{ __html: block.text }}
                />
            </div>
        </aside>
    );
};

export default ContentDefinitionBlock;
